import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import './PercentProgress.scss';

const PercentProgress = ({ percent }) => {
  return (
    <div className="grb-percentprogress">
      <CircularProgress size={48} value={percent} thickness={4} variant="static" />
      <span>{`${percent}%`}</span>
    </div>
  );
};

PercentProgress.propTypes = {
  percent: PropTypes.number.isRequired,
};

PercentProgress.defaultProps = {
};

export default PercentProgress;
